import { Badge, Button } from "@";
import OrderDetails from "./OrderDetails";
import OrderActivityTable from "./OrderActivityTable";

const OrderNotesModal = ({
  modalData,
  noteChange,
  noteLoading,
  addOrderNotes,
  editBankTransferSuccess,
}) => {
  const renderStatus = (isPaid) => (
    <Badge
      title={isPaid ? "مدفوعة" : "غير مدفوعة"}
      color={isPaid ? "green" : "red"}
    />
  );

  const renderPaymentType = (paymentType) => (
    <Badge
      title={paymentType === 0 ? "بطاقة" : "تحويل بنكي"}
      color={paymentType === 0 ? "default" : "dark"}
    />
  );

  const renderField = (
    label,
    value,
    isStatus = false,
    isPaymentType = false,
  ) => (
    <div className="text-gray-600 dark:text-gray-400">
      <span>{label} :</span>
      <span className="ms-2 font-semibold text-gray-700 dark:text-gray-400">
        {isStatus
          ? renderStatus(value)
          : isPaymentType
            ? renderPaymentType(value)
            : value}
      </span>
    </div>
  );

  return (
    <div className="bg-[#F8F8F8] dark:bg-gray-900 py-4 md:px-6 px-4">
      <form onSubmit={addOrderNotes} className="bg-[#F8F8F8] dark:bg-gray-900 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {renderField("حالة العملية", modalData?.isPaid, true)}
        {renderField("تاريخ ووقت العملية", modalData?.donationDate)}
        {renderField("مبلغ التبرع", modalData?.totalAmount)}
        {renderField("وسيلة التبرع", modalData?.paymentType, false, true)}
        {renderField("اسم المتبرع", modalData?.userName)}
        {renderField("جوال", modalData?.phoneNumber)}
        {modalData?.bankTransferFullUrl && <div className="text-gray-600 dark:text-gray-400">
          <span>الايصال :</span>
          <a
            target="_blank"
            href={modalData?.bankTransferFullUrl}
            className="ms-2 font-semibold text-blue-700 dark:text-blue-400"
          >
            عرض الإيصال
          </a>
        </div>}
        <div className="md:col-span-2 xl:col-span-3">
          <main className="card p-3">
            {/* Header */}
            <header className="flex-container">
              <label className="text-gray-600 dark:text-gray-400">
                تعديل الملاحظات
              </label>

              {/* Options */}
              <div className="options-container">
                <Button
                  type="submit"
                  title="حفظ الملاحظات"
                  isLoading={noteLoading}
                  className="py-2 text-sm"
                  disabled={noteLoading || !modalData.notes}
                />
              </div>
            </header>

            <textarea
              rows="5"
              className="input mt-3"
              value={modalData.notes || ""}
              onChange={(e) => noteChange(e.target.value)}
            ></textarea>
          </main>
        </div>

        {modalData.id && (
          <>
            <div className="overflow-x-scroll md:col-span-2 xl:col-span-3">
              <OrderDetails
                id={modalData.id}
                paymentType={modalData.paymentType}
                editSuccess={editBankTransferSuccess}
              />
            </div>
          </>
        )}
      </form>

      <OrderActivityTable key={modalData?.id} orderId={modalData?.id} />
    </div>
  );
};

export default OrderNotesModal;
